import { useEffect, useState, useRef } from "react";
import { Eye } from "lucide-react";

function seededRandom(seed) {
    let h = 0;
    for (let i = 0; i < seed.length; i++) h = Math.imul(31, h) + seed.charCodeAt(i) | 0;
    return () => { h ^= h << 13; h ^= h >> 17; h ^= h << 5; return (h >>> 0) / 4294967296; };
}

function getInitialCount(gameName) {
    const rng = seededRandom(gameName || "default");
    return 18 + Math.floor(rng() * 50);
}

const ViewerCount = ({ gameName = "" }) => {
    const [count, setCount] = useState(() => getInitialCount(gameName));
    const [flash, setFlash] = useState(false);
    const countRef = useRef(count);

    useEffect(() => {
        const initial = getInitialCount(gameName);
        setCount(initial);
        countRef.current = initial;
    }, [gameName]);

    useEffect(() => {
        countRef.current = count;
    }, [count]);

    useEffect(() => {
        let timer;
        const schedule = () => {
            const delay = 2000 + Math.random() * 3000;
            timer = setTimeout(() => {
                const delta = Math.floor(Math.random() * 3) + 1;
                const direction = Math.random() < 0.62 ? 1 : -1;
                const next = Math.max(12, Math.min(80, countRef.current + delta * direction));
                setCount(next);
                setFlash(true);
                setTimeout(() => setFlash(false), 700);
                schedule();
            }, delay);
        };
        schedule();
        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            <style>{`
                @keyframes liveDot {
                    0%, 100% { opacity: 1;   transform: scale(1);    box-shadow: 0 0 0 0   rgba(34,197,94,0.6); }
                    50%      { opacity: 0.65; transform: scale(0.82); box-shadow: 0 0 0 5px rgba(34,197,94,0);   }
                }
            `}</style>
            <div className="flex items-center gap-2 mt-2">
                <div
                    className="flex-shrink-0 w-2 h-2 rounded-full"
                    style={{
                        background: "#22c55e",
                        animation: "liveDot 2s ease-in-out infinite",
                        boxShadow: "0 0 6px rgba(34,197,94,0.8)",
                    }}
                />
                <span className="semiBold flex items-center gap-1.5" style={{ fontSize: "14px", color: "rgba(255,255,255,0.8)" }}>
                    <Eye className="w-3.5 h-3.5" style={{ color: "#89d4f5", flexShrink: 0 }} />
                    <span
                        style={{
                            color: flash ? "#22c55e" : "#fff",
                            transition: "color 0.6s ease",
                        }}
                    >
                        {count}
                    </span>{" "}
                    people viewing this right now
                </span>
            </div>
        </>
    );
};

export default ViewerCount;
